if (!customElements.get("slide-show")) {
  class e extends HTMLElement {
      constructor() {
          super();
          const e = this;
          let t = "true" === e.dataset.dots,
              s = Array.from(e.querySelectorAll(".carousel__slide")),
              i = "false" != e.dataset.autoplay && parseInt(e.dataset.autoplay, 10),
              a = "center" == e.dataset.align ? "center" : "left",
              l = "true" == e.dataset.fade,
              o = e.querySelector(".flickity-prev"),
              n = e.querySelector(".flickity-next"),
              r = e.querySelector(".flickity-page-dots"),
              c = e.parentNode.querySelector(".flickity-progress--bar"),
              d = [],
              u = "rtl" === document.dir,
              y = document.body.classList.contains("animations-true") && "undefined" != typeof gsap,
              h = 0,
              m = {
                  wrapAround: !0,
                  cellAlign: a,
                  pageDots: !1,
                  contain: !0,
                  fade: l,
                  autoPlay: i,
                  rightToLeft: u,
                  prevNextButtons: !1,
                  cellSelector: ".carousel__slide",
                  on: {},
              };
          if (s.length < 1) return;
          if (e.classList.contains("image-with-text-slideshow__image")) {
              let t = e.parentNode.querySelector(".image-with-text-slideshow__content"),
                  s = e.querySelectorAll(".image-with-text-slideshow__image-media");
              (m.draggable = !1),
                  (m.asNavFor = t),
                  s.length && s[0].classList.contains("desktop-height-auto") && (m.adaptiveHeight = !0);
          }
          if (e.classList.contains("customer-reviews__image")) {
              let t = e.parentNode.querySelector(".customer-reviews__content");
              (m.draggable = !1), (m.asNavFor = t);
          }
          (e.classList.contains("image-with-text-slideshow__content") ||
              e.classList.contains("testimonials__carousel") ||
              e.classList.contains("customer-reviews__content") ||
              e.classList.contains("customer-reviews__image")) &&
              (m.adaptiveHeight = !0),
              e.classList.contains("custom-dots") &&
                  (y && e.classList.contains("main-slideshow") && this.prepareAnimations(e, d),
                  (m.pauseAutoPlayOnHover = !1),
                  (m.on = {
                      staticClick: function () {
                          this.unpausePlayer();
                      },
                      ready: function () {
                          let s = this;
                          if (
                              (y &&
                                  e.classList.contains("main-slideshow") &&
                                  (e.animateSlides(0, d),
                                  gsap.set(e.querySelectorAll(".subheading,.split-text,.button"), {
                                      visibility: "visible",
                                  })),
                              t && r)
                          ) {
                              let e = r.querySelectorAll("li");
                              e.forEach((e, t) => {
                                  e.addEventListener("click", (e) => {
                                      s.select(t);
                                  });
                              }),
                                  e[this.selectedIndex].classList.add("is-selected");
                          }
                          document.fonts.ready.then(function () {
                              s.resize();
                          });
                          let i = s.cells[0].element.querySelector(".slideshow__slide-video-bg");
                          i &&
                              (i.querySelector("iframe")
                                  ? (i.querySelector("iframe").onload = function () {
                                        e.videoPlay(i);
                                    })
                                  : i.querySelector("video") &&
                                    (i.querySelector("video").onloadstart = function () {
                                        e.videoPlay(i);
                                    }));
                      },
                      change: function (s) {
                          let a = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);
                          if (
                              (y &&
                                  e.classList.contains("main-slideshow") &&
                                  (setTimeout(() => {
                                      e.animateReverse(a, d);
                                  }, 300),
                                  e.animateSlides(s, d)),
                              t && r)
                          ) {
                              let e = r.querySelectorAll("li");
                              e.forEach((e, t) => {
                                  e.classList.remove("is-selected");
                              }),
                                  e[this.selectedIndex].classList.add("is-selected");
                          }
                          i && (this.stopPlayer(), this.playPlayer());
                          let l = p.cells[a].element.querySelector(".slideshow__slide-video-bg");
                          l && e.videoPause(l);
                          let o = p.cells[s].element.querySelector(".slideshow__slide-video-bg");
                          o &&
                              (o.querySelector("iframe")
                                  ? o.querySelector("iframe").classList.contains("lazyload")
                                      ? (o
                                            .querySelector("iframe")
                                            .addEventListener("lazybeforeunveil", e.videoPlay(o)),
                                        lazySizes.loader.checkElems())
                                      : e.videoPlay(o)
                                  : o.querySelector("video") && e.videoPlay(o));
                      },
                  })),
              e.classList.contains("main-slideshow") &&
                  (e.classList.contains("desktop-height-image") || e.classList.contains("mobile-height-image")) &&
                  (m.adaptiveHeight = !0),
              e.classList.contains("products") &&
                  ((m.wrapAround = !1),
                  (m.on.ready = function () {
                      var t = this;
                      n &&
                          window.addEventListener("resize", function () {
                              e.centerArrows(t, o, n);
                          }),
                          window.dispatchEvent(new Event("resize"));
                  })),
              c &&
                  ((m.wrapAround = !1),
                  (m.on.scroll = function (e) {
                      (e = Math.max(0, Math.min(1, e))), (c.style.width = 100 * e + "%");
                  }));
          const p = new Flickity(e, m);
          (h = p.selectedIndex),
              (e.dataset.initiated = !0),
              o &&
                  (o.addEventListener("click", (e) => {
                      p.previous();
                  }),
                  o.addEventListener("keyup", (e) => {
                      p.previous();
                  }),
                  n.addEventListener("click", (e) => {
                      p.next();
                  }),
                  n.addEventListener("keyup", (e) => {
                      p.next();
                  })),
              Shopify.designMode &&
                  e.addEventListener("shopify:block:select", (e) => {
                      let t = s.indexOf(e.target);
                      p.select(t);
                  });
      }
      videoPause(e) {
          setTimeout(() => {
              "hosted" === e.dataset.provider
                  ? e.querySelector("video").pause()
                  : "youtube" === e.dataset.provider
                    ? e
                          .querySelector("iframe")
                          .contentWindow.postMessage(
                              JSON.stringify({ event: "command", func: "pauseVideo", args: "" }),
                              "*"
                          )
                    : "vimeo" === e.dataset.provider &&
                      e.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "pause" }), "*");
          }, 10);
      }
      videoPlay(e) {
          setTimeout(() => {
              "hosted" === e.dataset.provider
                  ? e.querySelector("video").play()
                  : "youtube" === e.dataset.provider
                    ? e
                          .querySelector("iframe")
                          .contentWindow.postMessage(
                              JSON.stringify({ event: "command", func: "playVideo", args: "" }),
                              "*"
                          )
                    : "vimeo" === e.dataset.provider &&
                      e.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
          }, 10);
      }
      prepareAnimations(e, t) {
          e.dataset.animationsReady ||
              (new SplitText(e.querySelectorAll("h1, p:not(.subheading)"), {
                  type: "lines, words",
                  linesClass: "line-child",
              }),
              e.querySelectorAll(".slideshow__slide").forEach((s, i) => {
                  let a = gsap.timeline({ paused: !0 }),
                      l = 0;
                  if (
                      ((t[i] = a),
                      "swipe" == e.dataset.transition &&
                          a.to(
                              s,
                              {
                                  duration: s.classList.contains("is-initial-selected") ? 0.2 : 0.7,
                                  clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)",
                              },
                              "start"
                          ),
                      a.to(s.querySelector(".slideshow__slide-bg"), { duration: 1.5, scale: 1 }, "start"),
                      s.querySelector(".subheading") &&
                          (a.to(s.querySelector(".subheading"), { duration: 0.5, autoAlpha: 1 }, 0), (l += 0.5)),
                      s.querySelector("h1"))
                  ) {
                      let e = 0.5 + 0.05 * (s.querySelectorAll("h1 .line-child div").length - 1);
                      a.from(
                          s.querySelectorAll("h1 .line-child div"),
                          { duration: e, yPercent: "100", stagger: 0.05 },
                          0
                      ),
                          (l += e);
                  }
                  if (s.querySelector("p:not(.subheading)")) {
                      let e = 0.5 + 0.02 * (s.querySelectorAll("p:not(.subheading) .line-child div").length - 1);
                      a.from(
                          s.querySelectorAll("p:not(.subheading) .line-child div"),
                          { duration: e, yPercent: "100", stagger: 0.02 },
                          0
                      ),
                          (l += e);
                  }
                  s.querySelectorAll(".button") &&
                      a.fromTo(
                          s.querySelectorAll(".button"),
                          { y: "100%" },
                          { duration: 0.5, y: "0%", stagger: 0.1 },
                          0.2 * l
                      ),
                      (s.dataset.timeline = a);
              }),
              (e.dataset.animationsReady = !0));
      }
      animateSlides(e, t) {
          document.fonts.ready.then(function () {
              t[e].timeScale(1).restart();
          });
      }
      animateReverse(e, t) {
          t[e].timeScale(3).reverse();
      }
      centerArrows(e, t, s) {
          let i = e.cells[0],
              a = 0,
              l = i.element.querySelector(".product-featured-image").clientHeight;
          if (
              (e.cells.forEach((e, t) => {
                  e.size.height > a && (a = e.size.height);
              }),
              a > l)
          ) {
              let e = (a - l) / -2;
              (t.style.transform = "translateY(" + e + "px)"), (s.style.transform = "translateY(" + e + "px)");
          }
      }
  }
  customElements.define("slide-show", e);
}
